import { Media } from 'graphql.generated';

type VirtualTour = {
    url: string;
    isSupported: boolean;
};

type VirtualTourList = Array<VirtualTour>;

const hasUrlProperty = (media: Media) => Boolean(media.url);

const buildCombinedVirtualTours = (
    tours: Media[],
    videos: Media[],
    links: Media[]
): VirtualTourList => {
    const supportedTours = [...tours, ...videos].filter(hasUrlProperty).map(
        (tour): VirtualTour =>
            ({
                isSupported: true,
                url: tour.url
            } as VirtualTour)
    );

    const unsupportedTours = links.filter(hasUrlProperty).map(
        (link) =>
            ({
                isSupported: false,
                url: link.url
            } as VirtualTour)
    );

    return [...supportedTours, ...unsupportedTours];
};

export default buildCombinedVirtualTours;
